// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__OVu1Y","title":"styles_title__4-7e_"};